export default {"src":"/_next/static/media/strip.53064374.svg","height":35,"width":470,"blurWidth":0,"blurHeight":0};